import { hasActiveDemoAccess } from "./demoAccess";
import { isClubWebsiteAllowed } from "./clubWebsiteAccess";
import { isAnalyticsProAllowed } from "./analyticsProAccess";

function feat(entitlements, key) {
  const f = entitlements?.features;
  if (!f) return false;
  if (key.startsWith("max_")) {
    const n = Number(f[key]);
    return Number.isFinite(n) && n > 0;
  }
  return Boolean(f[key]);
}

/** Доступные возможности текущего клуба (фичи приходят с API, в демо — «Максимальный»). */
export function resolvePlanAccess(entitlements, tenant, billing) {
  const demo = hasActiveDemoAccess(tenant, billing);
  const features = entitlements?.features;

  const f = (key) => {
    if (demo) {
      const demoFull = [
        "chat",
        "club_life",
        "member_social",
        "competitions",
        "polls",
        "polls_advanced",
        "branding",
        "branding_lite",
        "splash_branding",
        "analytics",
        "analytics_pro",
        "sales_funnel",
        "club_website",
        "admin_roles",
      ];
      if (demoFull.includes(key)) return true;
    }
    return feat(entitlements, key);
  };

  const limits = features || {};

  const chatEnabled = demo || Boolean(features?.chat);

  const fullBrandingEnabled = demo || Boolean(features?.branding);

  const brandingLiteEnabled =
    demo || fullBrandingEnabled || Boolean(features?.branding_lite);

  const analyticsProAllowed = isAnalyticsProAllowed(tenant);

  return {
    demo,
    chat: chatEnabled,
    clubLife: f("club_life"),
    memberSocial: f("member_social"),
    analytics: analyticsProAllowed && f("analytics"),
    analyticsPro: analyticsProAllowed && f("analytics_pro"),
    // Доступны всем клубам (не зависят от тарифа)
    salesFunnel: true,
    // Бета: только субдомен baysport
    clubWebsite: isClubWebsiteAllowed(tenant) && f("club_website"),
    analyticsExport: analyticsProAllowed && f("analytics_export"),
    polls: f("polls"),
    pollsAdvanced: f("polls_advanced"),
    finance: f("finance"),
    onlineAcquiring: f("online_acquiring"),
    branding: fullBrandingEnabled,
    brandingLite: brandingLiteEnabled,
    splashBranding: f("splash_branding"),
    whiteLabel: f("white_label"),
    competitions: f("competitions"),
    trainerPortal: f("trainer_portal"),
    multiTrainer: f("multi_trainer"),
    adminRoles: true,
    multiBranch: f("multi_branch"),
    prioritySupport: f("priority_support"),
    fullBranding: fullBrandingEnabled,
    showPortalBrandingTab: fullBrandingEnabled || brandingLiteEnabled,
    limits: {
      trainers: limits.max_trainers ?? 1,
      clients: limits.max_clients,
      directions: limits.max_directions,
      branches: limits.max_branches,
      clubs: limits.max_clubs,
    },
  };
}